export const TITLE = 'Form Title';
export const PLACEHOLDER = 'General Biology Assessment #1';
